import React from "react";
import { useSelector, useDispatch } from "react-redux";
import ReactDatePicker from "../../../components/reactDatePicker/reactDatePicker";
import { actionCreators } from "../redux/studioInfoSagas";
import { useDateFormat } from "../../../hooks/useDateFormat";

export const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { startDate, endDate } = useSelector((state) => state.studioInfo.selectedRequestDates);

  const { calendarEndDate, calendarStartDate } = useSelector(
    (state) => state.studioInfo.currentUser
  );

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      isRangePicker
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      minDate={calendarStartDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate, endDate }))
      }
    />
  );
};
